import { ReactNode } from "react";
import { View } from "./View";

export interface ILeftRightSectionProps {
  leftText: ReactNode;
  rightText: ReactNode;
  hasBorder: boolean;
  className?: string;
}

export const LeftRightSection = (props: ILeftRightSectionProps) => {
  return <View {...props} />;
};
